module.exports = __webpack_public_path__ + "static/media/agc009.28e6262f.jpg";